import React from 'react';
import { motion } from 'framer-motion';

/** Shared route entrance so navigation settles instead of snapping. */
export function PageTransition({
  children
}: {
  children: React.ReactNode;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -6
  }} transition={{
    duration: 0.24,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-64" data-mp="2z2hg0vzgqjtj">
      {children}
    </motion.div>;
}